import { BrickDefinition } from '../../../../samwebDescription/samweb/brickDefinition';

export class PublishNewBrickDefinitions {
   public static readonly type = '[Brick Definitions] Publish new brick definitions';

   constructor(public brickDefinitions: BrickDefinition[]) {}
}
